import React from 'react';
import { Link } from 'react-router-dom';
import { MinusIcon, PlusIcon, TrashIcon } from 'lucide-react';
import { CartItem as CartItemType } from '../../types';
import { formatPrice } from '../../utils/formatters';
import { useCart } from '../../context/CartContext';
interface CartItemProps {
  item: CartItemType;
}
export function CartItem({
  item
}: CartItemProps) {
  const {
    updateQuantity,
    removeItem
  } = useCart();
  const {
    product,
    quantity
  } = item;
  return <div className="flex gap-4 py-4 border-b border-gray-100 last:border-0" data-id="element-41">
      {/* Image */}
      <Link to={`/product/${product.slug}`} className="flex-shrink-0" data-id="element-42">
        <img src={product.images[0]} alt={product.name} className="w-20 h-20 md:w-24 md:h-24 object-cover rounded-lg" data-id="element-43" />
      </Link>

      {/* Details */}
      <div className="flex-1 min-w-0" data-id="element-44">
        <Link to={`/product/${product.slug}`} data-id="element-45">
          <h3 className="font-medium text-gray-900 hover:text-primary-600 transition-colors line-clamp-2" data-id="element-46">
            {product.name}
          </h3>
        </Link>
        <p className="text-sm text-gray-500 mt-1" data-id="element-47">{product.brand}</p>

        <div className="flex items-center justify-between mt-3" data-id="element-48">
          {/* Quantity controls */}
          <div className="flex items-center gap-2" data-id="element-49">
            <button onClick={() => updateQuantity(product.id, quantity - 1)} className="w-8 h-8 rounded-lg border border-gray-200 flex items-center justify-center text-gray-600 hover:bg-gray-50 transition-colors" aria-label="Decrease quantity" data-id="element-50">
              <MinusIcon className="w-4 h-4" data-id="element-51" />
            </button>
            <span className="w-10 text-center font-medium" data-id="element-52">{quantity}</span>
            <button onClick={() => updateQuantity(product.id, quantity + 1)} className="w-8 h-8 rounded-lg border border-gray-200 flex items-center justify-center text-gray-600 hover:bg-gray-50 transition-colors" aria-label="Increase quantity" data-id="element-53">
              <PlusIcon className="w-4 h-4" data-id="element-54" />
            </button>
          </div>

          {/* Price */}
          <div className="text-right" data-id="element-55">
            <p className="font-semibold text-gray-900" data-id="element-56">
              {formatPrice(product.price * quantity)}
            </p>
            {quantity > 1 && <p className="text-xs text-gray-500" data-id="element-57">
                {formatPrice(product.price)} each
              </p>}
          </div>
        </div>
      </div>

      {/* Remove button */}
      <button onClick={() => removeItem(product.id)} className="flex-shrink-0 p-2 text-gray-400 hover:text-red-500 transition-colors" aria-label={`Remove ${product.name} from cart`} data-id="element-58">
        <TrashIcon className="w-5 h-5" data-id="element-59" />
      </button>
    </div>;
}